var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "application-page" },
    [
      _c(
        "b-container",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "3" } },
                [_c("Navigation", { attrs: { page: "job-edit" } })],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { md: "9" } },
                [
                  _c(
                    "div",
                    {
                      directives: [{ name: "sticky", rawName: "v-sticky" }],
                      staticClass: "sticky-title"
                    },
                    [_c("h1", [_vm._v("Mein Jobwunsch")])]
                  ),
                  _vm._v(" "),
                  _vm.loading && !_vm.initiallyLoadedJob
                    ? _c("Loading")
                    : _c("div", { staticClass: "main-content profile-view" }, [
                        _c(
                          "div",
                          {
                            class: [
                              "tag-sections",
                              {
                                "loading-blockade":
                                  _vm.loading && _vm.initiallyLoadedJob
                              }
                            ]
                          },
                          _vm._l(_vm.groupedItems, function(group) {
                            return _c(
                              "section",
                              { key: group.category.id },
                              [
                                _c("Title", {
                                  attrs: {
                                    title: group.category.label,
                                    parent: "",
                                    editable: false,
                                    "completion-type": _vm.getCategoryCompletionType(
                                      group.category
                                    )
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "sub-sections" },
                                  _vm._l(group.sections, function(section) {
                                    return _c(
                                      "div",
                                      {
                                        key: section.id,
                                        staticClass: "sub-section"
                                      },
                                      [
                                        _c("Title", {
                                          attrs: {
                                            title: _vm.getSectionLabel(section),
                                            "completion-type": _vm.getSectionCompletedType(
                                              section
                                            ),
                                            tooltip: _vm.getSectionTooltip(
                                              section
                                            )
                                          },
                                          on: {
                                            edit: function($event) {
                                              return _vm.edit(section)
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        section.id === "function"
                                          ? _c("SelectedItems", {
                                              attrs: {
                                                "characteristic-items":
                                                  _vm.meta.function,
                                                "characteristic-type":
                                                  _vm.meta.functionType,
                                                selected: _vm.filterLastLevel(
                                                  _vm.job.functions
                                                ),
                                                "label-type":
                                                  _vm.labelTypeApplication,
                                                flat: "",
                                                "none-info":
                                                  "Alle Tätigkeiten möglich"
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        section.id === "employment-mode"
                                          ? _c("SelectedItems", {
                                              attrs: {
                                                "characteristic-items":
                                                  _vm.meta.employmentMode,
                                                "characteristic-type":
                                                  _vm.meta.employmentModeType,
                                                selected: _vm.filterLastLevel(
                                                  _vm.job.employmentMode
                                                ),
                                                "label-type":
                                                  _vm.labelTypeApplication,
                                                flat: ""
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        section.id === "working-time"
                                          ? _c("SelectedItems", {
                                              attrs: {
                                                "characteristic-items":
                                                  _vm.meta.workingTime,
                                                "characteristic-type":
                                                  _vm.meta.workingTimeType,
                                                selected: _vm.filterLastLevel(
                                                  _vm.job.workingTime
                                                    .workingTime
                                                ),
                                                "label-type":
                                                  _vm.labelTypeApplication,
                                                "none-info": "Keine",
                                                flat: ""
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        section.id === "geo"
                                          ? _c("SelectedItems", {
                                              attrs: {
                                                "characteristic-items":
                                                  _vm.geoItems,
                                                "characteristic-type":
                                                  _vm.meta.geoType,
                                                selected: _vm.job.geo,
                                                "label-type":
                                                  _vm.labelTypeApplication,
                                                "no-children-appendix": {
                                                  1: "Alle Regionen/Bezirke möglich"
                                                }
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        section.id === "career-level"
                                          ? _c("SelectedItems", {
                                              attrs: {
                                                "characteristic-items":
                                                  _vm.meta.careerLevel,
                                                "characteristic-type":
                                                  _vm.meta.careerLevelType,
                                                selected: _vm.filterLastLevel(
                                                  _vm.job.careerLevels
                                                ),
                                                "label-type":
                                                  _vm.labelTypeApplication,
                                                flat: ""
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        section.id === "industrial-sector"
                                          ? _c("SelectedItems", {
                                              attrs: {
                                                "characteristic-items":
                                                  _vm.meta.industrialSector,
                                                "characteristic-type":
                                                  _vm.meta.industrialSectorType,
                                                selected: _vm.filterLastLevel(
                                                  _vm.job.industrialSectors
                                                ),
                                                "label-type":
                                                  _vm.labelTypeApplication,
                                                flat: "",
                                                "none-info":
                                                  "Alle Branchen möglich"
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        section.id === "organisational-area"
                                          ? _c("SelectedItems", {
                                              attrs: {
                                                "characteristic-items":
                                                  _vm.meta.organisationalArea,
                                                "characteristic-type":
                                                  _vm.meta
                                                    .organisationalAreaType,
                                                selected: _vm.filterLastLevel(
                                                  _vm.job.organisationalArea
                                                ),
                                                "label-type":
                                                  _vm.labelTypeApplication,
                                                flat: "",
                                                "none-info":
                                                  "Alle Organisationsbereiche möglich"
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        section.id === "function-marketing-role"
                                          ? _c("SelectedItems", {
                                              attrs: {
                                                "characteristic-items":
                                                  _vm.meta
                                                    .functionMarketingRole,
                                                "characteristic-type":
                                                  _vm.meta
                                                    .functionMarketingRoleType,
                                                selected: _vm.filterLastLevel(
                                                  _vm.job.functionMarketingRole
                                                ),
                                                "label-type":
                                                  _vm.labelTypeApplication,
                                                flat: ""
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        section.id === "function-legal-role"
                                          ? _c("SelectedItems", {
                                              attrs: {
                                                "characteristic-items":
                                                  _vm.meta.functionLegalRole,
                                                "characteristic-type":
                                                  _vm.meta
                                                    .functionLegalRoleType,
                                                selected: _vm.filterLastLevel(
                                                  _vm.job.functionLegalRole
                                                ),
                                                "label-type":
                                                  _vm.labelTypeApplication,
                                                flat: ""
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        section.id === "function-legal-field"
                                          ? _c("SelectedItems", {
                                              attrs: {
                                                "characteristic-items":
                                                  _vm.meta.functionLegalField,
                                                "characteristic-type":
                                                  _vm.meta
                                                    .functionLegalFieldType,
                                                selected: _vm.filterLastLevel(
                                                  _vm.job.functionLegalField
                                                ),
                                                "label-type":
                                                  _vm.labelTypeApplication,
                                                flat: ""
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        section.id === "function-tax-role"
                                          ? _c("SelectedItems", {
                                              attrs: {
                                                "characteristic-items":
                                                  _vm.meta.functionTaxRole,
                                                "characteristic-type":
                                                  _vm.meta.functionTaxRoleType,
                                                selected: _vm.filterLastLevel(
                                                  _vm.job.functionTaxRole
                                                ),
                                                "label-type":
                                                  _vm.labelTypeApplication,
                                                flat: ""
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        section.id === "function-tax-field"
                                          ? _c("SelectedItems", {
                                              attrs: {
                                                "characteristic-items":
                                                  _vm.meta.functionTaxField,
                                                "characteristic-type":
                                                  _vm.meta.functionTaxFieldType,
                                                selected: _vm.filterLastLevel(
                                                  _vm.job.functionTaxField
                                                ),
                                                "label-type":
                                                  _vm.labelTypeApplication,
                                                flat: ""
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        section.id === "search-status" &&
                                        _vm.job.searchStatus
                                          ? _c("SelectedItems", {
                                              staticClass: "inline",
                                              attrs: {
                                                "characteristic-items":
                                                  _vm.meta.searchStatus,
                                                "characteristic-type":
                                                  _vm.meta.searchStatusType,
                                                selected: [
                                                  _vm.job.searchStatus
                                                    .searchStatus
                                                ],
                                                "label-type":
                                                  _vm.labelTypeApplication,
                                                flat: ""
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        section.id === "parking" &&
                                        _vm.job.parking
                                          ? _c("Parking", {
                                              attrs: { data: _vm.job.parking }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        section.id === "home-office" &&
                                        _vm.job.homeOffice
                                          ? _c("HomeOffice", {
                                              attrs: {
                                                data: _vm.job.homeOffice
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        section.id === "start-date" &&
                                        _vm.job.startDate !== undefined
                                          ? _c("StartDate", {
                                              attrs: { data: _vm.job.startDate }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        section.id === "public-transport" &&
                                        _vm.job.publicTransport
                                          ? _c("SelectedItems", {
                                              staticClass: "inline",
                                              attrs: {
                                                "characteristic-items":
                                                  _vm.meta.publicTransport,
                                                "characteristic-type":
                                                  _vm.meta.publicTransportType,
                                                selected: _vm.filterLastLevel(
                                                  _vm.job.publicTransport
                                                    .publicTransport
                                                ),
                                                "label-type":
                                                  _vm.labelTypeApplication,
                                                flat: "",
                                                "none-info": "Egal"
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        section.id === "company-car" &&
                                        _vm.job.companyCar !== undefined
                                          ? _c("CompanyCar", {
                                              attrs: {
                                                data: _vm.job.companyCar
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        section.id ===
                                          "private-vehicle-company-usage" &&
                                        _vm.job.privateVehicleCompanyUsage !==
                                          undefined
                                          ? _c("PrivateVehicleCompanyUsage", {
                                              attrs: {
                                                data:
                                                  _vm.job
                                                    .privateVehicleCompanyUsage
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        section.id === "customer-contact" &&
                                        _vm.job.customerContact
                                          ? _c("IrrelevantOrDesireOrNone", {
                                              attrs: {
                                                "characteristic-items":
                                                  _vm.meta.businessModel,
                                                "characteristic-type":
                                                  _vm.meta.businessModelType,
                                                data: _vm.job.customerContact
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        section.id === "company-size" &&
                                        _vm.job.companySize
                                          ? _c("SelectedItems", {
                                              staticClass: "inline",
                                              attrs: {
                                                "characteristic-items":
                                                  _vm.meta.companySize,
                                                "characteristic-type":
                                                  _vm.meta.companySizeType,
                                                selected: _vm.filterLastLevel(
                                                  _vm.job.companySize
                                                ),
                                                "label-type":
                                                  _vm.labelTypeApplication,
                                                flat: "",
                                                "none-info":
                                                  "Egal - alle sind möglich"
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        section.id === "company-type" &&
                                        _vm.job.companyType
                                          ? _c("SelectedItems", {
                                              staticClass: "inline",
                                              attrs: {
                                                "characteristic-items":
                                                  _vm.meta.companyType,
                                                "characteristic-type":
                                                  _vm.meta.companyTypeType,
                                                selected: _vm.filterLastLevel(
                                                  _vm.job.companyType
                                                ),
                                                "label-type":
                                                  _vm.labelTypeApplication,
                                                flat: "",
                                                "none-info":
                                                  "Egal - alle sind möglich"
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        section.id === "overtime" &&
                                        _vm.job.overtime
                                          ? _c("Overtime", {
                                              attrs: { data: _vm.job.overtime }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        section.id === "management" &&
                                        _vm.job.management
                                          ? _c("IrrelevantOrDesireOrNone", {
                                              attrs: {
                                                "characteristic-items":
                                                  _vm.meta.managementKind,
                                                "characteristic-type":
                                                  _vm.meta.managementKindType,
                                                data: _vm.job.management
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        section.id === "relocation" &&
                                        _vm.job.relocation
                                          ? _c("Relocation", {
                                              attrs: {
                                                data: _vm.job.relocation
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        section.id === "travel-willingness" &&
                                        _vm.job.travelWillingness
                                          ? _c("TravelWillingness", {
                                              attrs: {
                                                data: _vm.job.travelWillingness
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        section.id === "salary" &&
                                        _vm.job.salary !== undefined
                                          ? _c("Salary", {
                                              attrs: {
                                                job: _vm.job,
                                                data: _vm.job.salary
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        section.id === "hourly-rate" &&
                                        _vm.job.hourlyRate !== undefined
                                          ? _c("HourlyRate", {
                                              attrs: {
                                                job: _vm.job,
                                                data: _vm.job.hourlyRate
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        section.id === "employment-duration" &&
                                        _vm.job.employmentDuration
                                          ? _c("EmploymentDuration", {
                                              attrs: {
                                                data: _vm.job.employmentDuration
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        section.id === "working-hours" &&
                                        _vm.job.workingHours
                                          ? _c("WorkingHours", {
                                              attrs: {
                                                data: _vm.job.workingHours
                                              }
                                            })
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  }),
                                  0
                                )
                              ],
                              1
                            )
                          }),
                          0
                        )
                      ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }